
import React, { useState } from "react";
import { Button } from "@mui/material";

const grades = ["19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45"];

export default function GradeFormulario({ gradeNumeracao = {}, onChange, onEncaixeManual, componentesOptions = [], onSaveGrade, idProduto = null, apiBase = '', itemsList = [], selectedItems = [] }) {
  const [numero, setNumero] = useState(grades[0]);
  const [consumo, setConsumo] = useState(gradeNumeracao[grades[0]] || '');
  const [targetItemId, setTargetItemId] = useState(selectedItems && selectedItems.length === 1 ? selectedItems[0] : (itemsList && itemsList[0] ? itemsList[0].id : null));

  // States for Consulta Grade (inside this modal)
  const [consultaNumero, setConsultaNumero] = useState(grades[0] || '');
  const [consultaComponente, setConsultaComponente] = useState('');
  const [consultaTriggered, setConsultaTriggered] = useState(false);

  // Helper to read grade numeracao from an item (accepts multiple backend shapes)
  const getGradeNumeracao = (item) => {
    if (!item) return {};
    if (item.gradeNumeracao && typeof item.gradeNumeracao === 'object') return item.gradeNumeracao;
    if (item.grade_numeracao_json) {
      try {
        return typeof item.grade_numeracao_json === 'string' ? JSON.parse(item.grade_numeracao_json) : item.grade_numeracao_json;
      } catch (e) {
        return {};
      }
    }
    if (item.gradeNumeracaoJson) {
      try {
        return typeof item.gradeNumeracaoJson === 'string' ? JSON.parse(item.gradeNumeracaoJson) : item.gradeNumeracaoJson;
      } catch (e) {
        return {};
      }
    }
    return item.grade || {};
  };

  // Sincroniza consumo local quando a gradeNumeracao do pai mudar
  React.useEffect(() => {
    const newVal = gradeNumeracao[numero] || '';
    console.log('[DEBUG] GradeFormulario sync consumo:', { numero, newVal, gradeNumeracao });
    setConsumo(newVal);
  }, [gradeNumeracao, numero]);

  // Atualiza consumo para o número selecionado
  const handleConsumoChange = (value) => {
    setConsumo(value);
    const novo = { ...gradeNumeracao, [numero]: value };
    if (onChange) onChange(novo);
  };

  // Atualiza número e campo de consumo
  const handleNumeroChange = (e) => {
    const novoNumero = e.target.value;
    setNumero(novoNumero);
    setConsumo(gradeNumeracao[novoNumero] || '');
  };

  // componente removido — seleção de componente não é mais necessária aqui

  

  return (
    <div style={{ margin: '10px 0', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <label style={{ fontWeight: 600 }}>Cadastrar Consumo por Grade/Número</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <select value={targetItemId || ''} onChange={e => setTargetItemId(e.target.value)} style={{ minWidth: 220 }}>
          <option value="">Selecionar item alvo (opcional)</option>
          {itemsList && itemsList.map(it => (
            <option key={it.id} value={it.id}>{`${it.id} — ${it.componentes || ''} ${it.tamanho ? `(${it.tamanho})` : ''}`}</option>
          ))}
        </select>
        <select value={numero} onChange={handleNumeroChange} style={{ minWidth: 70 }}>
          {grades.map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
        <input
          type="number"
          value={consumo}
          onChange={e => handleConsumoChange(e.target.value)}
          placeholder="Consumo"
          className="form-control"
          style={{ width: 90, height: '28px', fontSize: '0.95rem' }}
          min="0"
          step="0.01"
        />
        <Button
          size="small"
          variant="outlined"
          style={{ minWidth: 0, padding: '2px 6px', fontSize: 12 }}
          onClick={() => onEncaixeManual && onEncaixeManual(numero)}
        >
          Encaixe Manual
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          style={{ minWidth: 0, padding: '4px 8px', fontSize: 12 }}
          onClick={() => {
            // Atualiza estado pai imediatamente
            const novo = { ...gradeNumeracao, [numero]: consumo };
            if (onChange) onChange(novo);
            // Chama callback de salvar (pode persistir no backend) e passa targetItemId selecionado (ou undefined)
            if (onSaveGrade) onSaveGrade(numero, consumo, undefined, targetItemId);
          }}
        >
          Salvar
        </Button>
        {/* Consulta separada: botão removido da linha principal e colocado na seção abaixo */}
      </div>
      {/* Componente select removido conforme solicitado */}
      
      {/* Consultar Grade dentro do modal de Cadastrar Grade */}
      <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid #eee' }}>
        <label style={{ fontWeight: 600 }}>Consultar Grade</label>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 6, flexWrap: 'wrap' }}>
          <div>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Número</label>
            <select value={consultaNumero} onChange={e => setConsultaNumero(e.target.value)}>
              {grades.map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Componente</label>
            <select value={consultaComponente} onChange={e => setConsultaComponente(e.target.value)}>
              <option value="">-- Todos --</option>
              {Array.from(new Set((componentesOptions || []).filter(Boolean))).map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>

          <Button size="small" variant="contained" onClick={() => setConsultaTriggered(prev => !prev)}>Consultar</Button>
        </div>

        <div style={{ marginTop: 8, overflowX: 'auto' }}>
          <table border="1" style={{ borderCollapse: 'collapse', width: '100%', minWidth: 520 }}>
            <thead>
              <tr>
                <th style={{ padding: '6px 8px' }}>Componente</th>
                <th style={{ padding: '6px 8px', textAlign: 'center' }}>Número</th>
                <th style={{ padding: '6px 8px', textAlign: 'center' }}>Consumo</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (!consultaTriggered) return (<tr><td colSpan={3} style={{ padding: 12, textAlign: 'center' }}>Selecione número e componente, depois clique em Consultar</td></tr>);

                const itensFiltrados = (itemsList || []).filter(it => {
                  if (!consultaComponente) return true;
                  return String(it.componentes).toLowerCase() === String(consultaComponente).toLowerCase();
                });

                if (itensFiltrados.length === 0) return (<tr><td colSpan={3} style={{ padding: 12, textAlign: 'center' }}>Nenhum item encontrado para os filtros</td></tr>);

                return itensFiltrados.map(item => {
                  const grade = getGradeNumeracao(item) || {};
                  const valor = (consultaNumero && grade && (grade[consultaNumero] !== undefined && grade[consultaNumero] !== null)) ? grade[consultaNumero] : '-';
                  return (
                    <tr key={item.id || item.codigo || item.componentes}>
                      <td style={{ padding: '6px 8px', maxWidth: 260, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.componentes || '-'}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'center' }}>{consultaNumero || '-'}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'center' }}>{valor}</td>
                    </tr>
                  );
                });
              })()}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
